import React, { useEffect, useState } from "react";

import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as Strings from "../commons/string";
import * as Common from "../commons/common";
import * as Utils from "../utils/utils";
import { Button, Modal } from "antd";
import DataTable from "./DataTable";
import { ColumnsType } from "antd/lib/table";

function ModalChangeRentCar({
    open,
    onChangedOpen,
    rentCars,
    onChangedRentCar,
}: {
    open: boolean;
    onChangedOpen: (open: boolean) => void;
    rentCars: Types.RentCarDto[];
    onChangedRentCar: (rentCarId: number) => void;
}) {
    const [selectedRentCar, setSelectedRentCar] = useState<Types.RentCarDto>();

    const handleClose = () => {
        onChangedOpen(false);
    };

    useEffect(() => {
        console.log("rentCars", rentCars);
    }, [rentCars]);

    const onChanged = () => {
        selectedRentCar &&
            Modal.confirm({
                title: "차량변경",
                content: selectedRentCar.car.carNumber + "(으)로 변경하시겠습니까?",
                okText: "확인",
                onOk() {
                    onChangedRentCar(selectedRentCar.rentCarId);
                },
                cancelText: "취소",
                onCancel() {},
                centered: true,
            });
    };

    const columns: ColumnsType<Types.RentCarDto> = [
        {
            width: "70%",
            align: "center",
            title: "상품명",
            dataIndex: "title",
            ellipsis: true,
            key: "title",
            render: (_, row) => {
                if (row.title) {
                    return row.title;
                } else return Strings.dash;
            },
        },
        {
            align: "center",
            title: "차량번호",
            dataIndex: "carNumber",
            key: "carNumber",
            render: (_, row) => {
                if (row.car?.carNumber) {
                    return row.car?.carNumber;
                } else return Strings.dash;
            },
        },
    ];

    return (
        <Modal
            centered
            closable={false}
            className="login"
            open={open}
            title="차량변경"
            footer={[
                <Button key="back" onClick={handleClose}>
                    취소
                </Button>,
                <Button key="setPassword" type="primary" onClick={() => onChanged()}>
                    변경
                </Button>,
            ]}
        >
            <DataTable hasScroll={false} columns={columns} rowKey="rentCarId" dataSource={rentCars} onRow={(row) => setSelectedRentCar(row)} />
        </Modal>
    );
}

export default ModalChangeRentCar;
